/**
 * One chart palette for the whole app.
 *
 * Extracted from ChatChart so a second chart cannot start a second copy: two
 * palettes drift, and the day they disagree neither is the brand's.
 *
 * @module components/charts/chartPalette
 */

/** YDM brand colours, in the order charts should consume them. */
export const YDM_CHART_COLORS = [
  '#F7941D', // orange
  '#00BEF9', // cyan
  '#94F53A', // green
  '#FE4FFF', // pink
  '#4667FF', // blue
  '#F59E0B', // amber
  '#10B981', // emerald
  '#8B5CF6', // violet
] as const;

/**
 * Deliberately outside the brand palette: a folded "everything else" slice is
 * not an entity, and giving it a brand colour makes it read as one.
 */
export const NEUTRAL_SLICE_COLOR = '#9CA3AF';

/** Wraps, so a chart with more series than colours still renders. */
export const colorAt = (index: number): string =>
  YDM_CHART_COLORS[index % YDM_CHART_COLORS.length];
